// extracted by mini-css-extract-plugin
module.exports = {"wrap":"StonesWrapper_wrap__2XO5t"};